export type MapAssetType =
  | "displayIcon"
  | "listViewIcon"
  | "listViewIconTall"
  | "splash"
  | "stylizedBackgroundImage"
  | "premierBackgroundImage";

export interface MapAssets {
  displayIcon: string;
  listViewIcon: string;
  listViewIconTall: string;
  splash: string;
  stylizedBackgroundImage: string;
  premierBackgroundImage: string;
}

const CLOUDINARY_BASE =
  "https://res.cloudinary.com/xenesis/image/upload/valAssets";

const MAP_ASSET_TYPES: MapAssetType[] = [
  "displayIcon",
  "listViewIcon",
  "listViewIconTall",
  "splash",
  "stylizedBackgroundImage",
  "premierBackgroundImage",
];

function toCloudinaryMapName(mapId: string): string {
  return mapId.charAt(0).toUpperCase() + mapId.slice(1).toLowerCase();
}

export function getMapAssets(mapId: string): MapAssets {
  const mapName = toCloudinaryMapName(mapId);
  return MAP_ASSET_TYPES.reduce((assets, type) => {
    assets[type] = `${CLOUDINARY_BASE}/${type}_${mapName}.png`;
    return assets;
  }, {} as MapAssets);
}

export function getMapAsset(mapId: string, type: MapAssetType): string {
  return getMapAssets(mapId)[type];
}
